// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/payPeriodHours.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9878: ONE pay-period hours rule — the company workweek behind
// window.TenantLocalTime, Payroll Prep and the Claude connector's
// get_payroll_hours run the same code.)
//
// Side-effect module (UMD): attaches `window.PayPeriodHours`; Node tests get it
// from require(). tenantLocalTime.js and clock.js read it at CALL time.
//
// The body below is the canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================
(function (root) {
  'use strict';

  var PPH_DEFAULT_TZ = 'America/Chicago';
  var PPH_PERIOD_TYPES = ['weekly', 'biweekly', 'semimonthly', 'monthly'];
  var PPH_PER_DIEM_DAY_HOURS = 8;
  var PPH_EPS = 1e-9;

  // ── zone + wall-clock math (TASK-1507: verbatim from tenantLocalTime.js) ────
  // One formatter per zone and a memo of validated zone names / day starts.
  // A swapped-out Intl (tests) invalidates every cache.
  var _pphOkZones = {};
  var _pphOkZoneCount = 0;
  var _pphFmts = {};
  var _pphFmtCount = 0;
  var _pphDayStarts = {};
  var _pphDayStartCount = 0;
  var _pphCtor = null;
  function _pphCacheGuard() {
    if (_pphCtor !== Intl.DateTimeFormat) {
      _pphOkZones = {}; _pphOkZoneCount = 0;
      _pphFmts = {}; _pphFmtCount = 0;
      _pphDayStarts = {}; _pphDayStartCount = 0;
      _pphCtor = Intl.DateTimeFormat;
    }
  }

  /** True when Intl accepts `tz` as an IANA zone. */
  function pphValidZone(tz) {
    _pphCacheGuard();
    if (typeof tz !== 'string' || !tz) return false;
    if (_pphOkZones[tz] === true) return true;
    try { new Intl.DateTimeFormat('en-US', { timeZone: tz }).format(new Date(0)); } catch (e) { return false; }
    if (_pphOkZoneCount > 50) { _pphOkZones = {}; _pphOkZoneCount = 0; }
    _pphOkZones[tz] = true; _pphOkZoneCount++;
    return true;
  }

  /** The week zone: the one given (trimmed) when Intl accepts it, else Central. Week math never refuses. */
  function pphZone(tz) {
    var z = typeof tz === 'string' ? tz.trim() : '';
    if (!z) return PPH_DEFAULT_TZ;
    return pphValidZone(z) ? z : PPH_DEFAULT_TZ;
  }

  function _pphFmt(kind, tz) {
    _pphCacheGuard();
    var k = kind + '|' + tz;
    var f = _pphFmts[k];
    if (!f) {
      f = kind === 'off'
        ? new Intl.DateTimeFormat('en-US', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' })
        : new Intl.DateTimeFormat('en-CA', { timeZone: tz, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
      if (_pphFmtCount > 50) { _pphFmts = {}; _pphFmtCount = 0; }
      _pphFmts[k] = f; _pphFmtCount++;
    }
    return f;
  }

  // Offset (ms) of `tz` from UTC at instant `ms`. Throws on an unknown zone.
  function _pphOffsetMs(ms, tz) {
    var p = {};
    _pphFmt('off', tz).formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
    var asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, (+p.hour) % 24, +p.minute, +p.second);
    return asUtc - Math.floor(ms / 1000) * 1000;
  }

  /** Wall-clock parts of instant `ms` in `tz`: { ymd, hh, mm }, or null. */
  function pphWallParts(ms, tz) {
    if (typeof ms !== 'number' || !isFinite(ms)) return null;
    try {
      var p = {};
      _pphFmt('wall', tz).formatToParts(new Date(ms)).forEach(function (x) { p[x.type] = x.value; });
      return { ymd: p.year + '-' + p.month + '-' + p.day, hh: (+p.hour) % 24, mm: +p.minute };
    } catch (e) { return null; }
  }

  function _pphWallMatches(ms, ymd, hh, mm, tz) {
    var p = pphWallParts(ms, tz);
    return !!p && p.ymd === ymd && p.hh === hh && p.mm === mm;
  }

  // Every instant whose wall clock in `tz` reads ymd HH:MM, earliest first
  // ([] = spring-forward gap, two = the repeated fall-back hour, null = unknown zone).
  function _pphCandidates(ymd, hh, mm, tz) {
    var parts = String(ymd).split('-').map(Number);
    var y = parts[0], m = parts[1], d = parts[2];
    if (!y || !m || !d || !isFinite(hh) || !isFinite(mm)) return [];
    if (!pphValidZone(tz)) return null;
    var guess = Date.UTC(y, m - 1, d, hh, mm);
    try {
      var offs = [];
      [-86400000, 0, 86400000].forEach(function (k) {
        var o = _pphOffsetMs(guess + k, tz);
        if (offs.indexOf(o) === -1) offs.push(o);
      });
      var out = [];
      offs.forEach(function (off) {
        var ms = guess - off;
        if (_pphWallMatches(ms, ymd, hh, mm, tz) && out.indexOf(ms) === -1) out.push(ms);
      });
      return out.sort(function (a, b) { return a - b; });
    } catch (e) {
      return null;
    }
  }

  // ── the COMPANY workweek (TASK-1507 / TASK-9979) ────────────────────────────
  function _pphYmdParts(ymd) { return String(ymd).split('-').map(Number); }

  /** Calendar arithmetic on 'YYYY-MM-DD' (no zone, no DST). */
  function pphAddDaysYmd(ymd, n) {
    var p = _pphYmdParts(ymd);
    return new Date(Date.UTC(p[0], p[1] - 1, p[2] + (Number(n) || 0))).toISOString().slice(0, 10);
  }
  function _pphDowYmd(ymd) { var p = _pphYmdParts(ymd); return new Date(Date.UTC(p[0], p[1] - 1, p[2])).getUTCDay(); }

  /** The workweek start day, sanitised: an integer 0 (Sun) … 6 (Sat), anything else → 0. */
  function pphStartDay(sd) { var n = Number(sd); return (n === Math.floor(n) && n >= 0 && n <= 6) ? n : 0; }

  /** The company calendar date ('YYYY-MM-DD') instant `ms` falls on, or null. */
  function pphCompanyYmd(ms, tz) {
    var p = pphWallParts(ms, pphZone(tz));
    return p ? p.ymd : null;
  }

  /**
   * 12:00 AM of a company date, as an instant. A zone whose clocks skip
   * midnight starts the day at the first minute that exists. Memoized per
   * zone+date (never a failure).
   */
  function pphDayStartMs(ymd, tz) {
    var z = pphZone(tz);
    _pphCacheGuard();
    var k = z + '|' + ymd;
    if (Object.prototype.hasOwnProperty.call(_pphDayStarts, k)) return _pphDayStarts[k];
    var out = NaN;
    for (var h = 0; h < 4; h++) {
      var c = _pphCandidates(ymd, h, 0, z);
      if (c && c.length) { out = c[0]; break; }
    }
    if (isFinite(out)) {
      if (_pphDayStartCount > 5000) { _pphDayStarts = {}; _pphDayStartCount = 0; }
      _pphDayStarts[k] = out; _pphDayStartCount++;
    }
    return out;
  }

  /** Week key (the start day's company date, 'YYYY-MM-DD') of instant `ms`, or null. */
  function pphWeekKey(ms, startDay, tz) {
    var ymd = pphCompanyYmd(ms, tz);
    if (!ymd) return null;
    var diff = _pphDowYmd(ymd) - pphStartDay(startDay);
    if (diff < 0) diff += 7;
    return pphAddDaysYmd(ymd, -diff);
  }

  /** { key, startMs, endMs, lastYmd } — endMs = the last ms before the next week starts. */
  function pphWeekRangeOfKey(key, tz) {
    var next = pphAddDaysYmd(key, 7);
    return { key: key, startMs: pphDayStartMs(key, tz), endMs: pphDayStartMs(next, tz) - 1, lastYmd: pphAddDaysYmd(key, 6) };
  }
  function pphWeekRange(ms, startDay, tz) {
    var key = pphWeekKey(ms, startDay, tz);
    return key ? pphWeekRangeOfKey(key, tz) : null;
  }

  /** 0..6 — which day of its workweek instant `ms` falls on (company calendar), -1 if unreadable. */
  function pphWeekDayIndex(ms, startDay, tz) {
    var ymd = pphCompanyYmd(ms, tz);
    var key = pphWeekKey(ms, startDay, tz);
    if (!ymd || !key) return -1;
    var a = _pphYmdParts(ymd), b = _pphYmdParts(key);
    return Math.round((Date.UTC(a[0], a[1] - 1, a[2]) - Date.UTC(b[0], b[1] - 1, b[2])) / 86400000);
  }

  /** The week key holding CALENDAR DAY ymd (a pay-period bound). */
  function pphWeekKeyOfYmd(ymd, startDay) {
    var diff = _pphDowYmd(ymd) - pphStartDay(startDay);
    if (diff < 0) diff += 7;
    return pphAddDaysYmd(ymd, -diff);
  }

  /** A pay period given as calendar days → company-zone instants { startMs, endMs }. */
  function pphPeriodBoundsYmd(startYmd, endYmd, tz) {
    if (!startYmd || !endYmd) return { startMs: NaN, endMs: NaN };
    return { startMs: pphDayStartMs(startYmd, tz), endMs: pphDayStartMs(pphAddDaysYmd(endYmd, 1), tz) - 1 };
  }

  // ── pay settings + the pay-period grid ──────────────────────────────────────

  /**
   * The tenant's pay settings, normalized. `settings` is tenants/{tid}.settings
   * (or, in the browser, the values clock.js's getters return). Same defaults
   * as clock.js: biweekly, workweek Monday (1), OT after 40 h. `tz` = the
   * company zone (the week zone).
   */
  function pphConfig(settings, tz) {
    var s = settings || {};
    // COD (re-port r1): truthy-or-default, exactly clock.js getPayPeriodType — an
    // unknown value yields no period (null), never a silent biweekly.
    var t = s.payPeriodType ? s.payPeriodType : 'biweekly';
    var wd = s.workWeekStartDay;
    wd = (wd === null || wd === undefined) ? 1 : wd;
    var thr = s.overtimeThreshold;
    thr = (thr === null || thr === undefined) ? 40 : Number(thr);
    return {
      payPeriodType: t,
      payPeriodAnchor: s.payPeriodAnchor ? String(s.payPeriodAnchor) : null,
      workWeekStartDay: wd,
      overtimeThreshold: thr,
      tz: pphZone(tz)
    };
  }

  /**
   * A saved biweekly anchor → its calendar date 'YYYY-MM-DD', or null when it is
   * not a date. Read EXACTLY as clock.js getPayPeriodAnchor always has —
   * new Date(raw + 'T00:00:00') and that Date's own calendar parts — so a value
   * the release line could not read ('2026-13-05') is still refused, and one it
   * rolled ('2026-02-30' → Mar 2) rolls the same way (COD re-port r1).
   */
  function pphAnchorYmd(raw) {
    if (!raw) return null;
    var d = new Date(String(raw) + 'T00:00:00');
    if (isNaN(d.getTime())) return null;
    return _pphYmdOf(d.getFullYear(), d.getMonth() + 1, d.getDate());
  }
  function _pphYmdOf(y, m, d) { return new Date(Date.UTC(y, m - 1, d)).toISOString().slice(0, 10); }

  /**
   * The pay period `offset` periods from the one holding "today" (0 = current,
   * -1 = the last closed one). `todayYmd` = the caller's calendar day (Payroll
   * Prep: the device's; omitted → the company's, from `nowMs`). Returns
   *   { type, startYmd, endYmd, startMs, endMs }   (company-zone instants)
   *   { type, invalid: true }                      (a saved anchor that is not a date)
   *   null                                         (an unknown period type)
   * Mirrors the release clock.js getPayPeriodDates (TASK-1193: the biweekly grid
   * comes from the anchor by calendar days, never from the workweek).
   */
  function pphPayPeriod(offset, cfg, nowMs, todayYmd) {
    var off = Number(offset) || 0;
    var tz = cfg.tz;
    var today = todayYmd || pphCompanyYmd(nowMs, tz);
    var tp = _pphYmdParts(today);
    var startYmd, endYmd;
    if (cfg.payPeriodType === 'weekly') {
      var wk = pphWeekKey(nowMs, cfg.workWeekStartDay, tz);
      if (!wk) return { type: cfg.payPeriodType, invalid: true };
      startYmd = pphAddDaysYmd(wk, off * 7);
      endYmd = pphAddDaysYmd(startYmd, 6);
    } else if (cfg.payPeriodType === 'biweekly') {
      var anchor;
      if (cfg.payPeriodAnchor) {
        anchor = pphAnchorYmd(cfg.payPeriodAnchor);
        if (!anchor) return { type: cfg.payPeriodType, invalid: true };
      } else {
        // Default: the company workweek holding now.
        anchor = pphWeekKey(nowMs, cfg.workWeekStartDay, tz);
        if (!anchor) return { type: cfg.payPeriodType, invalid: true };
      }
      var ap = _pphYmdParts(anchor);
      var dayDiff = (Date.UTC(tp[0], tp[1] - 1, tp[2]) - Date.UTC(ap[0], ap[1] - 1, ap[2])) / 86400000;
      var idx = Math.floor(dayDiff / 14);
      startYmd = pphAddDaysYmd(anchor, (idx + off) * 14);
      endYmd = pphAddDaysYmd(startYmd, 13);
    } else if (cfg.payPeriodType === 'semimonthly') {
      // 1st–15th and 16th–end of month.
      var totalHalves = (tp[2] <= 15 ? 0 : 1) + off;
      var monthOffset = Math.floor(totalHalves / 2);
      var half = ((totalHalves % 2) + 2) % 2;
      if (half === 0) { startYmd = _pphYmdOf(tp[0], tp[1] + monthOffset, 1); endYmd = _pphYmdOf(tp[0], tp[1] + monthOffset, 15); }
      else { startYmd = _pphYmdOf(tp[0], tp[1] + monthOffset, 16); endYmd = _pphYmdOf(tp[0], tp[1] + monthOffset + 1, 0); }
    } else if (cfg.payPeriodType === 'monthly') {
      startYmd = _pphYmdOf(tp[0], tp[1] + off, 1);
      endYmd = _pphYmdOf(tp[0], tp[1] + off + 1, 0);
    } else {
      return null;
    }
    var b = pphPeriodBoundsYmd(startYmd, endYmd, tz);
    return { type: cfg.payPeriodType, startYmd: startYmd, endYmd: endYmd, startMs: b.startMs, endMs: b.endMs };
  }

  /**
   * The clock-entry read range for a period (calendar days): every full
   * company workweek the period touches (TASK-949 — straddling weeks are scored
   * on their FULL-week hours). { startMs, endMs } company-zone instants.
   */
  function pphQueryWindow(startYmd, endYmd, cfg) {
    var a = pphWeekKeyOfYmd(startYmd, cfg.workWeekStartDay);
    var b = pphWeekKeyOfYmd(endYmd, cfg.workWeekStartDay);
    return { startMs: pphDayStartMs(a, cfg.tz), endMs: pphWeekRangeOfKey(b, cfg.tz).endMs };
  }

  // ── people + hours ──────────────────────────────────────────────────────────

  /** An entry's clock-in as epoch ms, read exactly as clock.js reads it (toDate(), else new Date(v)). */
  function pphEntryMs(v) {
    var d = (v && typeof v.toDate === 'function') ? v.toDate() : null;
    return (d || new Date(v)).getTime();
  }

  /**
   * Payroll OT-exempt (TITS policy, Chris 2026-06-03: salaried = no OT) plus the
   * FLSA flags. `person` must already carry its comp fields (peopleComp merged
   * over the person doc — PersonComp.effective in the browser).
   * TASK-9394: mca_exempt is exempt from overtime only, like ot_exempt.
   */
  function pphIsPayrollExempt(person) {
    if (!person) return false;
    return person.hrEmploymentType === 'salary'
      || person.flsaStatus === 'ot_exempt'
      || person.flsaStatus === 'mca_exempt'
      || person.flsaStatus === 'exempt'
      || person.hrOvertimeExempt === true;
  }

  /**
   * TASK-949 — one person's regular / overtime for one pay period, per COMPANY
   * workweek (TASK-1507).
   *   1. A straddling week's FULL-week OT is paid in the period the week ENDS in.
   *   2. Regular = the week's first `threshold` hours, allocated chronologically:
   *      in-period regular = max(0, min(inHours, threshold - beforeHours)).
   *   3. A week that ends in the NEXT period pays straight time only here.
   *   4. Exempt: every in-period hour is regular, OT 0.
   *   5. A week that ended BEFORE the period started is not "ending here".
   * Only COMPLETED entries with hours count (open shifts have no settled hours).
   * Each entry's hours go to its clock-IN instant (start-date wins).
   * `entries` = the person's WEEK-EXPANDED entries (pphQueryWindow), never a
   * capped or paged list. `pStartMs` / `pEndMs` = the period's company-zone
   * instants. An unreadable clock-in on a completed shift THROWS — a report
   * that cannot place a shift in a workweek must fail loudly, never pay short.
   */
  function pphCrossPeriodOT(entries, person, pStartMs, pEndMs, cfg) {
    var threshold = cfg.overtimeThreshold;
    var exempt = pphIsPayrollExempt(person);
    var weeks = {};
    (entries || []).forEach(function (entry) {
      if (entry.status !== 'completed') return;
      var hrs = entry.totalHours || 0;
      if (!hrs) return;
      var t = pphEntryMs(entry.clockIn);
      var wr = pphWeekRange(t, cfg.workWeekStartDay, cfg.tz);
      if (!wr) throw new Error('Clock entry ' + (entry.id || '?') + ' has an unreadable clock-in time — fix it before running payroll.');
      if (!weeks[wr.key]) {
        weeks[wr.key] = { fullTotal: 0, beforeHours: 0, inHours: 0, afterHours: 0, weekEndMs: wr.endMs };
      }
      var w = weeks[wr.key];
      w.fullTotal += hrs;
      if (t < pStartMs) w.beforeHours += hrs;
      else if (t > pEndMs) w.afterHours += hrs;
      else w.inHours += hrs;
    });
    var periodReg = 0, periodOT = 0, straddleNoteApplies = false;
    var weekList = Object.keys(weeks).sort().map(function (key) {
      var w = weeks[key];
      var endsInPeriod = w.weekEndMs <= pEndMs && w.weekEndMs >= pStartMs;
      // Skip a week only if it has NO in-period hours AND does not END here (a
      // week can end in a period with 0 hours logged in it; its OT still lands here).
      if (w.inHours <= PPH_EPS && !endsInPeriod) {
        return { key: key, fullTotal: w.fullTotal, reg: 0, ot: 0, endsInPeriod: false, beforeHours: w.beforeHours, straddle: false, skipped: true };
      }
      var reg, ot;
      if (exempt) {
        reg = w.inHours;
        ot = 0;
      } else {
        reg = Math.max(0, Math.min(w.inHours, threshold - w.beforeHours));
        ot = endsInPeriod ? Math.max(0, w.fullTotal - threshold) : 0;
      }
      var straddle = !exempt && endsInPeriod && w.beforeHours > PPH_EPS && (w.fullTotal - threshold) > PPH_EPS;
      if (straddle) straddleNoteApplies = true;
      periodReg += reg;
      periodOT += ot;
      return { key: key, fullTotal: w.fullTotal, reg: reg, ot: ot, endsInPeriod: endsInPeriod, beforeHours: w.beforeHours, straddle: straddle };
    });
    return { exempt: exempt, periodTotal: periodReg + periodOT, periodReg: periodReg, periodOT: periodOT, straddleNoteApplies: straddleNoteApplies, weeks: weekList };
  }

  /**
   * TASK-939 — add one entry's hours to its clock-IN calendar date in `dayTz`
   * (Payroll Prep passes the device zone, as it always has; the server the
   * company zone).
   */
  function pphAddDateHours(dateHours, clockIn, hrs, dayTz) {
    if (!dateHours || !(hrs > 0)) return;
    var t = pphEntryMs(clockIn);
    if (!isFinite(t)) return;
    var p = pphWallParts(t, pphZone(dayTz));
    if (!p) return;
    dateHours[p.ymd] = (dateHours[p.ymd] || 0) + hrs;
  }

  /** TASK-939 — per-diem days = distinct dates with ≥ 8 h of completed hours. */
  function pphPerDiemDays(dateHours) {
    var n = 0;
    Object.keys(dateHours || {}).forEach(function (k) { if (dateHours[k] >= PPH_PER_DIEM_DAY_HOURS - PPH_EPS) n++; });
    return n;
  }

  /**
   * TASK-10034 — the last day of a person marked No Longer Employed, as
   * YYYY-MM-DD, or null when they are not (or no date can be read).
   * lastDayWorked (what the office typed) wins; then the legacy terminationDate
   * string; then terminatedAt (a Timestamp, Date or date string) read in `tz`.
   */
  function pphLastDayYmd(person, tz) {
    if (!person) return null;
    var term = person.terminated === true || !!person.terminationDate;
    if (!term) return null;
    var ymdRe = /^\d{4}-\d{2}-\d{2}$/;
    var a = typeof person.lastDayWorked === 'string' ? person.lastDayWorked.trim() : '';
    if (ymdRe.test(a)) return a;
    var b = typeof person.terminationDate === 'string' ? person.terminationDate.trim().slice(0, 10) : '';
    if (ymdRe.test(b)) return b;
    var t = person.terminatedAt;
    if (t) {
      if (typeof t === 'string' && ymdRe.test(t.trim().slice(0, 10))) return t.trim().slice(0, 10);
      var ms = pphEntryMs(t);
      if (isFinite(ms)) return pphCompanyYmd(ms, tz);
    }
    return null;
  }

  /**
   * TASK-10034 — is this roster person on payroll for the pay period that
   * starts on `periodStartYmd`? Active people: yes. Inactive (still employed,
   * temporarily not working): no, as before. No Longer Employed: yes through the
   * pay period that contains their last day, then no. A No Longer Employed person
   * with no readable last day is not kept (the old rule) — their hours, if any,
   * still list them. tz = the company zone (only a terminatedAt-only record needs it).
   */
  function pphOnPayroll(person, periodStartYmd, tz) {
    if (!person) return false;
    var term = person.terminated === true || !!person.terminationDate;
    if (!term) return person.active !== false;
    var last = pphLastDayYmd(person, tz);
    if (!last || typeof periodStartYmd !== 'string' || !periodStartYmd) return false;
    return last >= periodStartYmd;
  }

  /**
   * The hours half of Payroll Prep, for every person, in one call.
   *   input = {
   *     weekEntries   — every clock entry with clockIn in pphQueryWindow(period)
   *                     (full list — never capped), clockIn ascending
   *     activePeople  — people docs read with active == true (raw)
   *     nameOf(pid)   — the RAW person's name or undefined (Payroll Prep names
   *                     an entry by entry.personName, then the person doc)
   *     personOf(pid) — the person with comp merged in, or null
   *     startMs, endMs — the period's company-zone instants
   *     cfg, dayTz    — pay settings; the per-diem calendar zone (default cfg.tz)
   *   }
   * Returns { rows, byPid } — rows sorted by name (localeCompare). Row:
   *   { pid, name, exempt, isSalary, reg, ot, total, rawHours, weeks, straddle,
   *     perDiemEligible, perDiemDays (null when no per-diem rate), dateHours,
   *     missingClockOuts (open shifts in the period), completedEntries, inactive,
   *     otDetail (the full pphCrossPeriodOT result) }
   * Membership is Payroll Prep's: anyone with an entry whose clock-in is in the
   * period (open or closed), plus every roster person pphOnPayroll keeps for the
   * period (salaried / zero-hour people still appear). TASK-10034: pass
   * `periodStartYmd` so a person marked No Longer Employed stays listed through
   * the pay period that contains their last day; without it the old rule holds
   * (terminated people are listed only when they have an entry in the period).
   * Each row carries `lastDayYmd` (null unless No Longer Employed).
   */
  function pphBuildPeriodHours(input) {
    var cfg = input.cfg;
    var dayTz = input.dayTz || cfg.tz;
    var sMs = input.startMs, eMs = input.endMs;
    var personOf = typeof input.personOf === 'function' ? input.personOf : function () { return null; };
    var nameOf = typeof input.nameOf === 'function' ? input.nameOf : function (pid) { var p = personOf(pid); return p ? p.name : undefined; };
    var weekEntries = input.weekEntries || [];
    var activePeople = input.activePeople || [];
    var perPerson = Object.create(null); // COD r3: person ids are data — "constructor" / "toString" must not hit Object.prototype
    var order = [];
    function ensure(pid, name) {
      if (!perPerson[pid]) { perPerson[pid] = { pid: pid, name: name, rawHours: 0, dateHours: {}, missingClockOuts: 0, completedEntries: 0 }; order.push(pid); }
      return perPerson[pid];
    }
    var byPidEntries = Object.create(null);
    weekEntries.forEach(function (e) {
      if (e && e.personId) (byPidEntries[e.personId] = byPidEntries[e.personId] || []).push(e);
    });
    weekEntries.forEach(function (e) {
      var t = pphEntryMs(e.clockIn);
      if (!(t >= sMs && t <= eMs)) return;
      var pid = e.personId;
      if (!pid) return;
      var agg = ensure(pid, e.personName || nameOf(pid) || 'Unknown');
      var hrs = e.totalHours || 0;
      var completed = e.status === 'completed';
      if (!completed) agg.missingClockOuts++;
      if (completed && hrs) {
        agg.rawHours += hrs;
        agg.completedEntries++;
        pphAddDateHours(agg.dateHours, e.clockIn, hrs, dayTz);
      }
    });
    var activeIds = Object.create(null);
    activePeople.forEach(function (p) {
      if (!p) return;
      if (!(p.active === false || p.terminated)) activeIds[p.id] = true;
    });
    var periodStartYmd = typeof input.periodStartYmd === 'string' ? input.periodStartYmd : null;
    activePeople.forEach(function (p) {
      if (!p) return;
      if (periodStartYmd ? !pphOnPayroll(p, periodStartYmd, cfg.tz) : (p.active === false || p.terminated)) return;
      ensure(p.id, p.name);
    });
    var rows = order.map(function (pid) {
      var agg = perPerson[pid];
      var person = personOf(pid) || {};
      var ot = pphCrossPeriodOT(byPidEntries[pid] || [], person, sMs, eMs, cfg);
      var perDiemRate = parseFloat(person.hrPerDiem) || 0;
      var perDiemEligible = perDiemRate > 0;
      return {
        pid: pid,
        name: agg.name,
        exempt: ot.exempt,
        isSalary: person.hrEmploymentType === 'salary',
        reg: ot.periodReg,
        ot: ot.periodOT,
        total: ot.periodTotal,
        rawHours: agg.rawHours,
        weeks: ot.weeks,
        straddle: ot.straddleNoteApplies,
        perDiemEligible: perDiemEligible,
        perDiemDays: perDiemEligible ? pphPerDiemDays(agg.dateHours) : null,
        dateHours: agg.dateHours,
        missingClockOuts: agg.missingClockOuts,
        completedEntries: agg.completedEntries,
        inactive: !activeIds[pid],
        lastDayYmd: pphLastDayYmd(person, cfg.tz),
        otDetail: ot
      };
    }).sort(function (a, b) { return String(a.name).localeCompare(String(b.name)); });
    var byPid = Object.create(null);
    rows.forEach(function (r) { byPid[r.pid] = r; });
    return { rows: rows, byPid: byPid };
  }

  var api = Object.freeze({
    DEFAULT_TZ: PPH_DEFAULT_TZ,
    PERIOD_TYPES: PPH_PERIOD_TYPES.slice(),
    PER_DIEM_DAY_HOURS: PPH_PER_DIEM_DAY_HOURS,
    validZone: pphValidZone,
    zone: pphZone,
    wallParts: pphWallParts,
    addDaysYmd: pphAddDaysYmd,
    startDay: pphStartDay,
    companyYmd: pphCompanyYmd,
    dayStartMs: pphDayStartMs,
    weekKey: pphWeekKey,
    weekRangeOfKey: pphWeekRangeOfKey,
    weekRange: pphWeekRange,
    weekDayIndex: pphWeekDayIndex,
    weekKeyOfYmd: pphWeekKeyOfYmd,
    periodBoundsYmd: pphPeriodBoundsYmd,
    config: pphConfig,
    anchorYmd: pphAnchorYmd,
    payPeriod: pphPayPeriod,
    queryWindow: pphQueryWindow,
    entryMs: pphEntryMs,
    isPayrollExempt: pphIsPayrollExempt,
    crossPeriodOT: pphCrossPeriodOT,
    addDateHours: pphAddDateHours,
    perDiemDays: pphPerDiemDays,
    lastDayYmd: pphLastDayYmd,
    onPayroll: pphOnPayroll,
    buildPeriodHours: pphBuildPeriodHours
  });
  if (root) root.PayPeriodHours = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
})(typeof window !== 'undefined' ? window : (typeof globalThis !== 'undefined' ? globalThis : null));
